module.exports = __webpack_public_path__ + "static/img/left1.395b9563.png";